export enum ImageCoverageMetrics {
  IMAGE_COVERAGE = 'IMAGE_COVERAGE',
}
